
const buildEvents = ({ lanesHorizontal, lanesVertical }) => {
  let draggingEnabled = true;

  const hoverLineColor = "rgba(192.0,0.0,0.0,0.5)";

  let isDragging = false;
  let dragStartX = -1;
  let dragStartY = -1;
  let dragIndex = -1;

  let laneEndsX = [];
  let laneEndsY = [];
  let lineWidth = 0;

  const calculateLaneEnds = (chart) => {
    const layout = chart._impl.layout;
    const layoutSettings = chart._impl.settings.layout.swimlane;
    lineWidth = layoutSettings.lineWidth;
    laneEndsX = [];
    laneEndsY = [];
    for(let i = 0; i < layout.numLanesX(); i++) {
      if(i === 0) {
	laneEndsX.push(0);
      }
      laneEndsX.push(layout.getLaneEndX(i));
    }
    for(let i = 0; i < layout.numLanesY(); i++) {
      if(i === 0) {
	laneEndsY.push(0);
      }
      laneEndsY.push(layout.getLaneEndY(i));
    }
  };


  return {
    onPointerDrag: (chart, e) => {
      // End lines are not draggable
      if(!draggingEnabled || !isDragging || dragIndex === 0) {
	return;
      }
      const chartPos = chart._impl.scene.fromDisplay(e.x, e.y);
      const distX = chartPos.x - dragStartX;
      const distY = chartPos.y - dragStartY;

      const minLaneWidth = 1;
      const isDraggingX = dragStartX !== -1;
      const isDraggingY = dragStartY !== -1;
      const laneEnds = isDraggingX ? laneEndsX : laneEndsY;
      const lanesToUpdate = isDraggingX ? lanesVertical : lanesHorizontal;
      const dragDist = isDraggingX ? distX : distY;
      const dragMin = dragIndex === 0 ? Number.NEGATIVE_INFINITY
      : laneEnds[dragIndex - 1];
      const dragMax = dragIndex === (laneEnds.length - 1) ? Number.POSITIVE_INFINITY
      : laneEnds[dragIndex + 1];
      if(isDraggingX || isDraggingY) {
	const newDragEnd = Math.max(dragMin + minLaneWidth,
				    Math.min(dragMax - minLaneWidth,
					     laneEnds[dragIndex] + dragDist));
	if(dragIndex > 0) {
	  lanesToUpdate[dragIndex - 1].laneWidth = newDragEnd - dragMin;
	}
	if(dragIndex < lanesToUpdate.length) {
	  lanesToUpdate[dragIndex].laneWidth = dragMax - newDragEnd;
	}
      }

      chart.updateSettings({
	layout: {
	  swimlane: {
	    lanesVertical,
	    lanesHorizontal
	  }
	}
      });

    },
    onPointerMove: (chart, e) => {
      if(!draggingEnabled || isDragging) {
	return;
      }
      let hasUpdated = false;
      const chartPos = chart._impl.scene.fromDisplay(e.x, e.y);
      const chartX = chartPos.x;
      const chartY = chartPos.y;
      laneEndsX.forEach((x, i) => {
	if(!(i > 0)) {
	  return;
	}
	let newColor = undefined;
	if(chartX > (x - lineWidth) && chartX < (x + lineWidth)) {
	  newColor = hoverLineColor;
	} else {
	  newColor = undefined;
	}
	if(lanesVertical[i - 1].lineColor !== newColor) {
	  lanesVertical[i - 1].lineColor = newColor;
	  hasUpdated = true;
	}
      });
      laneEndsY.forEach((y, i) => {
	if(!(i > 0)) {
	  return;
	}
	let newColor = undefined;
	if(chartY > (y - lineWidth) && chartY < (y + lineWidth)) {
	  newColor = hoverLineColor;
	} else {
	  newColor = undefined;
	}
	if(lanesHorizontal[i - 1].lineColor !== newColor) {
	  lanesHorizontal[i - 1].lineColor = newColor;
	  hasUpdated = true;
	}
      });
      if(hasUpdated) {
	chart.updateSettings({
	  layout: {
	    swimlane: {
	      lanesVertical,
	      lanesHorizontal
	    }
	  }
	});
      }
    },
    onPointerDown: (chart, e) => {
      if(!draggingEnabled) {
	return;
      }
      const chartPos = chart._impl.scene.fromDisplay(e.x, e.y);
      const chartX = chartPos.x;
      const chartY = chartPos.y;

      laneEndsX.forEach((x, i) => {
	if(chartX > (x - lineWidth) && chartX < (x + lineWidth)) {
	  dragStartX = chartX;
	  dragStartY = -1;
	  dragIndex = i;
	  isDragging = true;
	  // Ensure the line drag does not cause a pan
	  chart.updateSettings({
	    interaction: {
	      panning: {
		enabled: false
	      }
	    }
	  });
	}
      });
      laneEndsY.forEach((y, i) => {
	if(chartY > (y - lineWidth) && chartY < (y + lineWidth)) {
	  dragStartX = -1;
	  dragStartY = chartY;
	  dragIndex = i;
	  isDragging = true;
	  // Ensure the line drag does not cause a pan
	  chart.updateSettings({
	    interaction: {
	      panning: {
		enabled: false
	      }
	    }
	  });
	}
      });
    },
    onPointerUp: (chart, e) => {
      isDragging = false;
      chart.updateSettings({
	interaction: {
	  panning: {
	    enabled: true
	  }
	}
      });
    }
  }
}

export { buildEvents };
